import { styled as t, Accordion as m, AccordionSummary as p, Box as i, Typography as n, AccordionDetails as g } from "@mui/material";
import h from "../button/ImageButton.js";
import { jsxs as s, jsx as r } from "react/jsx-runtime";
const d = t(m)`
  background-image: linear-gradient(180deg, #1e2b35 0%, #191b1d 100%);
  border: 2px solid #2e303e;
`, w = t(p)`
  width: 100%;
  height: 10vw;
  padding: 0;
  ${(e) => e.theme.breakpoints.up("res768")} {
    height: 80px;
  }
  ${(e) => e.theme.breakpoints.up("res1280")} {
    height: 80px;
  }
  ${(e) => e.theme.breakpoints.up("res1600")} {
    height: 80px;
  }
  ${(e) => e.theme.breakpoints.up("res1920")} {
    height: 80px;
  }
`, c = t(i)`
  width: 4vw;
  height: 4vw;
  margin-left: 3.33vw;
  margin-right: 3.33vw;
  margin-top: 4.13vw;
  margin-bottom: 4.13vw;
  ${(e) => e.theme.breakpoints.up("res768")} {
    width: 1.5vw;
    height: 1.5vw;
    margin-left: 2.4vw;
    margin-right: 2.4vw;
    margin-top: 1.95vw;
    margin-bottom: 1.95vw;
  }
  ${(e) => e.theme.breakpoints.up("res1600")} {
    width: 24px;
    height: 24px;
  }
`, v = t(i)`
  margin-left: 4vw;
  margin-top: 1vw;
  margin-bottom: 1vw;
  ${(e) => e.theme.breakpoints.up("res768")} {
    margin-left: 3vw;
  }
  ${(e) => e.theme.breakpoints.up("res1280")} {
    margin-left: 2.34vw;
    margin-top: 1.72vw;
    margin-bottom: 1.72vw;
  }
  ${(e) => e.theme.breakpoints.up("res1600")} {
    margin-left: 1.875vw;
    margin-top: 1.375vw;
    margin-bottom: 1.375vw;
  }
  ${(e) => e.theme.breakpoints.up("res1920")} {
    margin-left: 2.057vw;
    margin-top: 1.146vw;
    margin-bottom: 1.146vw;
  }
`, l = t(i)`
  margin-left: 4vw;
  margin-right: 4vw;
  padding: 0;
  ${(e) => e.theme.breakpoints.down("res768")} {
  }
  ${(e) => e.theme.breakpoints.up("res768")} {
  }
  ${(e) => e.theme.breakpoints.up("res1280")} {
    margin-left: 2.34vw;
    margin-right: 2.34vw;
  }
  ${(e) => e.theme.breakpoints.up("res1600")} {
    margin-left: 1.875vw;
    margin-right: 1.875vw;
  }
  ${(e) => e.theme.breakpoints.up("res1920")} {
    margin-left: 2.057vw;
    margin-right: 2.057vw;
  }
`, k = ({
  children: e,
  title: o,
  icon: a
}) => /* @__PURE__ */ s(d, {
  defaultExpanded: !1,
  square: !0,
  children: [/* @__PURE__ */ r(w, {
    id: "panel1a-header",
    "aria-controls": "panel1a-content",
    expandIcon: /* @__PURE__ */ r(c, {
      children: /* @__PURE__ */ r(h, {
        image: `url(${a})`
      })
    }),
    children: /* @__PURE__ */ r(v, {
      children: /* @__PURE__ */ r(n, {
        color: "#FFFFFF",
        variant: "h5",
        children: o
      })
    })
  }), /* @__PURE__ */ r(g, {
    children: /* @__PURE__ */ r(l, {
      children: /* @__PURE__ */ r(n, {
        color: "#C8C8C8",
        component: "div",
        children: e
      })
    })
  })]
});
export {
  k as default
};
//# sourceMappingURL=InfoAccordion.js.map
